import { makeAutoObservable } from "mobx";

import type { AdminPermission } from "@/api/admin/teamRoles";

export class AdminAccessStore {
  permissions: AdminPermission[] = [];
  isBootstrapped = false;

  constructor() {
    makeAutoObservable(this);
  }

  setPermissions(permissions: AdminPermission[]) {
    this.permissions = permissions;
    this.isBootstrapped = true;
  }

  reset() {
    this.permissions = [];
    this.isBootstrapped = false;
  }
}
